module.exports = "/_next/static/images/solarEnergy2x-c530d166cd81519e12a0df16bada4636.png";